//----------------------
// extract player names
//----------------------
export default function extractPlayerNames(objArray) {
  let names = objArray.map((a) => a.first_name);
  return names;
}
